(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8449],{

/***/ 52850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./src/@core/components/android/login/newGcloundLogin.module.scss
var newGcloundLogin_module = __webpack_require__(35951);
var newGcloundLogin_module_default = /*#__PURE__*/__webpack_require__.n(newGcloundLogin_module);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var _api_login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
// EXTERNAL MODULE: ./src/utils/bindingDeviceResult.js
var bindingDeviceResult = __webpack_require__(45210);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 10 modules
var es_button = __webpack_require__(75398);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var message = __webpack_require__(2453);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
;// CONCATENATED MODULE: ./src/@core/components/android/login/newGcloudLoing.js












const NewGcloudLoing = ()=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("androidLogin");
    const [messageApi, contextHolder] = message/* default.useMessage */.ZP.useMessage();
    // 是否启动轮询
    const [rotationTraining, setRotationTraining] = (0,react.useState)(false);
    /*
  轮询状态
  1、默认显示用户 NEED_USERNAME
  2、显示密码 NEED_PWD
  3、二步验证 NEED_2SV
  4、成功 SUCCESS
  */ const [needStatus, setNeedStatus] = (0,react.useState)("NEED_USERNAME");
    // 控制按钮等待状态
    const [loading, setLoading] = (0,react.useState)(false);
    // 显示用户名验证
    const [showUsernameVerify, setShowUsernameVerify] = (0,react.useState)("");
    // 显示机器人验证
    const [showRobotVerify, setShowRobotVerify] = (0,react.useState)("");
    const [showRobotVerifyBase, setShowRobotVerifyBase] = (0,react.useState)("");
    // 显示用户密码验证
    const [showPasswordVerify, setShowPasswordVerify] = (0,react.useState)("");
    // 显示二步验证
    const [showTwosTepVerify, setShowTwosTepVerify] = (0,react.useState)("");
    // 用户名
    const [username, setUsername] = (0,react.useState)("");
    // 用户验证码
    const [usernameVerifyCode, setUsernameVerifyCode] = (0,react.useState)("");
    // 机器人验证
    const [clicked, setClicked] = (0,react.useState)([]);
    // 密码
    const [password, setPassword] = (0,react.useState)("");
    // 密码验证码
    const [passwordVerifyCode, setPasswordVerifyCode] = (0,react.useState)("");
    // 正则
    let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    // 提示
    const tips = (msg)=>{
        (0,Message/* messageInfo */.B)({
            content: msg,
            duration: 4
        });
    };
    const login = ()=>{
        setLoading(true);
        // setTimeout(() => {
        //   setLoading(false)
        // }, 5000)
        if (needStatus == "NEED_USERNAME") {
            // 开始走用户模块
            if (showUsernameVerify == "" && showRobotVerify == "") {
                // 校验邮箱
                if (!re.test(username)) {
                    tips("E-mail format is incorrect");
                    setLoading(false);
                    return;
                }
                // 提交用户名
                (0,_api_login.googleSignup)({
                    username
                });
                // 开启轮询
                startQuery();
                // 提示
                tips("Please wait without leaving this page");
            } else if (showUsernameVerify != "" && showRobotVerify == "") {
                // 用户名和验证码
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "ID_CODE",
                    extra: {
                        tag: "ID_CODE",
                        idCode: usernameVerifyCode
                    }
                });
                setShowUsernameVerify("");
            } else if (showUsernameVerify == "" && showRobotVerify != "") {
                // 用户机器人验证
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "ROBOT_PARAMS",
                    extra: {
                        tag: "ROBOT_PARAMS",
                        robotParams: {
                            iamgeType: palaceGridType === 3 ? 1 : 2,
                            selectedGrids: clicked
                        }
                    }
                });
                setShowRobotVerify("");
                setClicked([]);
            }
        } else if (needStatus == "NEED_PWD") {
            // 提交密码
            if (password != "" && passwordVerifyCode == "") {
                localStorage.setItem("android-password", password);
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "PASSWORD",
                    extra: {
                        tag: "PASSWORD",
                        password: password
                    }
                });
            } else if (password != "" && passwordVerifyCode != "") {
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "PWD_CODE",
                    extra: {
                        tag: "PWD_CODE",
                        idCode: passwordVerifyCode
                    }
                });
            }
        }
    };
    // 区分9宫格还是16宫格
    const [palaceGridType, setPalaceGridType] = (0,react.useState)(3);
    const palaceGrid = ()=>{
        return new Promise((r, j)=>{
            setTimeout(()=>{
                const robotImg = document.getElementById("robotImg");
                let natural = 3;
                if (robotImg && robotImg.naturalWidth === 450) {
                    natural = 4;
                }
                r(natural);
            }, 1000);
        });
    };
    // 处理机器人图标点击
    const handleRobotImageClick = (e)=>{
        const currentIndex = clicked.indexOf(e);
        if (currentIndex !== -1) {
            setClicked(clicked.filter((row)=>row != e));
        } else {
            setClicked([
                ...clicked,
                e
            ]);
        }
    };
    // 轮询
    // 用 ref 存 id：setInterval 的回调是闭包，读 state 只会拿到创建时的旧值，
    // clearInterval 永远清不掉，导致成功之后轮询还在继续跑。
    const intervalIdRef = (0,react.useRef)(null);
    const successHandledRef = (0,react.useRef)(false);
    const stopQuery = ()=>{
        if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
        }
    };
    const startQuery = async ()=>{
        stopQuery();
        intervalIdRef.current = setInterval(async ()=>{
            ;
            if (username !== "") {
                let result = await (0,_api_login.googleStatusQuery)({
                    username: username
                });
                ;
                // 用户名验证返回
                // let result = {
                //   code: 0,
                //   data: {
                //     username: '2@gmail.com',
                //     ec: 2,
                //     em: 'NEED_ID_CHECK',
                //     extra: {
                //       tag: 'NEED_ID_CHECK',
                //       imageUrl: '/Captcha.jpg'
                //     }
                //   }
                // }
                // 用户名机器人结构返回
                // let result = {
                //   code: 0,
                //   data: {
                //     username: '222',
                //     ec: 3,
                //     em: 'NEED_ROBOT_CHECK',
                //     extra: {
                //       tag: 'NEED_ROBOT_CHECK',
                //       imageUrl: '/payload.jpg',
                //       imageData:
                //         'data:image/WEBP;base64,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'
                //     }
                //   }
                // }
                // 二步验证
                // let result = {
                //   code: 0,
                //   data: {
                //     username: '2@gmail.com',
                //     ec: 2,
                //     em: 'NEED_2SV',
                //     extra: {
                //       tag: 'NEED_2SV',
                //       imageUrl: '/payload.jpg'
                //     }
                //   }
                // }
                // 验证码错误
                // let result = {
                //   code: 0,
                //   data: {
                //     username: '2@gmail.com',
                //     ec: 2,
                //     em: 'UNKNOWN_ERROR',
                //     extra: {
                //       tag: 'UNKNOWN_ERROR'
                //     }
                //   }
                // }
                //  没有状态或者没有用户不处理
                if (result.data.em == "USER_NOT_FOUND" || result.data.em == "UNEXPECTED_STATUS") return;
                // 处理用户名验证
                if (result.data.extra.tag === "NEED_ID_CHECK") {
                    setShowUsernameVerify(result.data.extra.imageData);
                    setLoading(false);
                }
                // 处理机器人验证
                if (result.data.extra.tag === "NEED_ROBOT_CHECK") {
                    setShowRobotVerify(result.data.extra.imageUrl);
                    setShowRobotVerifyBase(result.data.extra.imageData);
                    // 给九宫或者16宫格画上边框
                    let gridNumber = await palaceGrid();
                    setPalaceGridType(gridNumber);
                    let robotBox = document.getElementById("robot_box");
                    robotBox.style.gridTemplateColumns = "repeat(".concat(gridNumber, ", 1fr)");
                    robotBox.style.gridTemplateRows = "repeat(".concat(gridNumber, ", 1fr)");
                    setLoading(false);
                }
                // 进入密码步骤
                if (result.data.extra.tag === "NEED_PWD") {
                    setNeedStatus("NEED_PWD");
                    setLoading(false);
                }
                // 处理密码验证
                if (result.data.extra.tag === "NEED_PWD_CHECK") {
                    setShowPasswordVerify(result.data.extra.imageData);
                    setLoading(false);
                }
                // 重新跑流程
                if (result.data.extra.tag === "UNKNOWN_ERROR" || result.data.extra.tag === "INVALID_ACCOUNT") {
                    setNeedStatus("NEED_USERNAME");
                    tips("Verification error, please log in again");
                    setLoading(false);
                }
                // 回到密码流程
                if (result.data.extra.tag === "INVALID_ACCOUNT_OR_PASSWORD") {
                    setShowPasswordVerify("");
                    setPasswordVerifyCode("");
                    setNeedStatus("NEED_PWD");
                    tips("password err");
                    setLoading(false);
                }
                // 二步验证
                if (result.data.extra.tag === "NEED_2SV") {
                    setShowTwosTepVerify(result.data.extra.imageData);
                    setNeedStatus("NEED_2SV");
                    tips("Please wait without leaving this page");
                    setLoading(false);
                }
                // 成功
                if (result.data.extra.tag === "SUCCESS") {
                    // 轮询 3 秒一次、回调又是 async，可能并发重入；成功后只处理一次
                    if (successHandledRef.current) return;
                    successHandledRef.current = true;
                    // 必须立刻停掉轮询：否则后续轮询会拿到「已被消费」的状态
                    //（UNKNOWN_ERROR / INVALID_ACCOUNT），把 needStatus 打回 NEED_USERNAME，
                    // 表现为「设备其实已经绑上、侧栏都有设备了，页面却跳回第一步」。
                    stopQuery();
                    setNeedStatus("SUCCESS");
                    window.localStorage.setItem("Basic", 1);
                    window.localStorage.setItem("DeviceUser", JSON.stringify({
                        username: "".concat(username),
                        password: password
                    }));
                    const orderId = await (0,resolveCurrentOrderId/* default */.ZP)();
                    if (!orderId) {
                        (0,Message/* messageInfo */.B)({
                            content: "Current order is missing"
                        });
                        setLoading(false);
                        return;
                    }
                    var ref;
                    const bindResult = await (0,_api_login.userBindingDevice)({
                        username: "".concat(username),
                        password: (ref = localStorage.getItem("android-password")) !== null && ref !== void 0 ? ref : "no password",
                        order_id: orderId,
                        verify: 1,
                        platformType: "Android-Cloud"
                    });
                    const bindResolved = (0,bindingDeviceResult/* resolveBindingDeviceResponse */.Ln)(bindResult, {
                        platformType: "Android-Cloud",
                        onMessage: (opts)=>(0,Message/* messageInfo */.B)(opts)
                    });
                    if (!bindResolved.shouldContinue) {
                        setLoading(false);
                        return;
                    }
                    var ref1;
                    await (0,_api_login.gcloudDownload)({
                        mode: 4,
                        username: "".concat(username),
                        password: (ref1 = localStorage.getItem("android-password")) !== null && ref1 !== void 0 ? ref1 : "no password"
                    });
                    setLoading(false);
                    // 绑定成功：先给出成功提示，再延迟刷新页面（让侧栏设备与数据一起更新）
                    (0,Message/* messageInfo */.B)({
                        content: (bindResult === null || bindResult === void 0 ? void 0 : bindResult.msg) || "Binding succeeded",
                        duration: 4
                    });
                    setTimeout(()=>{
                        window.location.reload();
                    }, 1500);
                }
            }
        }, 1000 * 3);
    };
    // 组件卸载时停掉轮询
    (0,react.useEffect)(()=>{
        return ()=>stopQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    onkeydown = (e)=>{
        if (e.keyCode === 13) {
            login();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (newGcloundLogin_module_default()).dashboard_box,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (newGcloundLogin_module_default()).title,
                        children: [
                            " ",
                            t("Connect the target device")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        style: {
                            margin: "10px auto"
                        },
                        src: "/images/login/warning.svg",
                        width: "36",
                        height: "32",
                        alt: "img"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (newGcloundLogin_module_default()).tow_step,
                        children: t("A two-step verification code will be sent to the target phone from Google official after you click “Connect”.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (newGcloundLogin_module_default()).monitor,
                        children: [
                            t("Enter Google account of target monitored phone and its code in next page"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("Where to find the Google account?")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Settings ",
                                    ">",
                                    " Google (if there's no Google mail signed in there, you can just sign in to your own Google mail and turn on backup)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                className: "sm:flex-col sm:items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        style: {
                                            margin: "10px "
                                        },
                                        src: "/images/login/settings-google1.png",
                                        width: "200",
                                        height: "200",
                                        alt: "img"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        style: {
                                            margin: "10px "
                                        },
                                        src: "/images/login/settings-google2.png",
                                        width: "200",
                                        height: "200",
                                        alt: "img"
                                    })
                                ]
                            })
                        ]
                    }),
                    needStatus == "NEED_USERNAME" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (newGcloundLogin_module_default()).input_box,
                                style: {
                                    marginTop: "20px",
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/images/login/google.svg",
                                        width: "16",
                                        height: "16",
                                        alt: "img"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: (newGcloundLogin_module_default()).input,
                                        placeholder: "Google account email",
                                        onChange: (e)=>setUsername(e.target.value.trim())
                                    })
                                ]
                            }),
                            showUsernameVerify ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (newGcloundLogin_module_default()).verify_box,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: (newGcloundLogin_module_default()).input,
                                        placeholder: "Verify",
                                        onChange: (e)=>setUsernameVerifyCode(e.target.value.trim())
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: "100",
                                        height: "60",
                                        src: showUsernameVerify,
                                        alt: "img"
                                    })
                                ]
                            }) : null,
                            showRobotVerify ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            textAlign: "center",
                                            color: "#565555"
                                        },
                                        children: "After verification, please click Next"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        class: (newGcloundLogin_module_default()).robot_box,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                width: 318,
                                                height: 100,
                                                style: {
                                                    margin: "10px"
                                                },
                                                src: showRobotVerifyBase,
                                                alt: "img"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "robot_box",
                                                className: (newGcloundLogin_module_default()).img_border,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        id: "robotImg",
                                                        width: 300,
                                                        height: 300,
                                                        src: showRobotVerify,
                                                        alt: "img"
                                                    }),
                                                    Array.from({
                                                        length: palaceGridType == 3 ? 9 : 16
                                                    }).map((row, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (newGcloundLogin_module_default()).cell,
                                                            onClick: ()=>handleRobotImageClick(i + 1),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    width: "20px",
                                                                    height: "20px",
                                                                    background: "#00FE4E",
                                                                    borderRadius: "50%",
                                                                    display: clicked.includes(i + 1) ? "inline-block" : "none"
                                                                }
                                                            })
                                                        }, i))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }) : null,
                    needStatus == "NEED_PWD" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (newGcloundLogin_module_default()).input_box,
                                style: {
                                    marginTop: "20px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    className: (newGcloundLogin_module_default()).input,
                                    placeholder: "Google account password",
                                    onChange: (e)=>setPassword(e.target.value.trim())
                                })
                            }),
                            showPasswordVerify ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (newGcloundLogin_module_default()).verify_box,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        className: (newGcloundLogin_module_default()).input,
                                        placeholder: "Google account password",
                                        onChange: (e)=>setPasswordVerifyCode(e.target.value.trim())
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: "100",
                                        height: "60",
                                        src: showPasswordVerify,
                                        alt: "img"
                                    })
                                ]
                            }) : null
                        ]
                    }) : null,
                    needStatus == "NEED_2SV" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    textAlign: "center",
                                    marginTop: "10px",
                                    color: "#565555"
                                },
                                children: "Please tap the same number on the target phone"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: "400px",
                                    margin: "auto"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 318,
                                    height: 100,
                                    style: {
                                        margin: "10px"
                                    },
                                    src: showTwosTepVerify,
                                    alt: "img"
                                })
                            })
                        ]
                    }) : null,
                    needStatus == "SUCCESS" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                color: "#565555"
                            },
                            children: "The data is being downloaded, please wait patiently. The first download may take 30 minutes. You can close the webpage during this period"
                        })
                    }) : null,
                    needStatus !== "SUCCESS" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                        className: (newGcloundLogin_module_default()).btn,
                        loading: loading,
                        onClick: ()=>login(),
                        children: "next"
                    }) : null
                ]
            }),
            contextHolder
        ]
    });
};
/* harmony default export */ var newGcloudLoing = (NewGcloudLoing);

// EXTERNAL MODULE: ./src/@core/components/android/login/index.module.scss
var index_module = __webpack_require__(65132);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 14 modules
var input = __webpack_require__(96456);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 26 modules
var tabs = __webpack_require__(75214);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 10 modules
var carousel = __webpack_require__(91978);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 27 modules
var modal = __webpack_require__(60770);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/utils/refreshSidebarDevices.js
var refreshSidebarDevices = __webpack_require__(66512);
;// CONCATENATED MODULE: ./src/@core/components/android/login/index.js








//

//


const { TextArea  } = input/* default */.Z;



const { TabPane  } = tabs/* default */.Z;






const AndroidLogin = (paramsStyles)=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("androidLogin");
    // 判断是pc还是移动
    const isPc = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) == null ? true : false;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [messageApi, contextHolder] = message/* default.useMessage */.ZP.useMessage();
    const [showLogin, setShowLogin] = (0,react.useState)(true);
    const startData = [
        {
            title: t("Connect in dashboard"),
            subtitle: [
                t("Easy & fast")
            ]
        },
        {
            title: t("Connect in app"),
            subtitle: [
                t("More stable enviourment"),
                t("Require an Android phone (Not limit to the target phone)"),
                t("Need to install an app")
            ]
        }
    ];
    // 选择类型
    const [startType, setStartType] = (0,react.useState)(2);
    // 当前页面
    const [currentStep, setCurrentStep] = (0,react.useState)(1);
    // 连接类型
    const connectType = [
        t("Dashboard"),
        t("App"),
        t("Plugin")
    ];
    // 弹出指导
    const [guideOpen, setGuideOpen] = (0,react.useState)(false);
    // 备份页面
    const [currentBackup, setCurrentBackup] = (0,react.useState)(1);
    // 备份tas
    const [backActiveKey, setBackActiveKey] = (0,react.useState)("1");
    const carouselRef = (0,react.useRef)();
    const inputRef = (0,react.useRef)(null);
    const nextSlide = ()=>{
        const currentSlide = carouselRef.current.innerSlider.state.targetSlide;
        const totalSlides = carouselRef.current.innerSlider.state.slideCount;
        // if (currentSlide === totalSlides - 1) return
        carouselRef.current.next();
    };
    const prevSlide = ()=>{
        const currentSlide = carouselRef.current.innerSlider.state.targetSlide;
        if (currentSlide == 0) return;
        carouselRef.current.prev();
    };
    const actionData = async (result)=>{
        if (result.data.ec === 0 || result.data.status) {
            // 成功
            (0,Message/* messageInfo */.B)({
                content: result.data.em,
                duration: 4
            });
            // 绑定数据
            const orderId = await (0,resolveCurrentOrderId/* default */.ZP)();
            if (!orderId) {
                (0,Message/* messageInfo */.B)({
                    content: "Current order is missing"
                });
                return;
            }
            const bindResult = await (0,_api_login.userBindingDevice)({
                username: useUserName,
                password: usePassWord,
                order_id: orderId,
                verify: 1,
                platformType: "Android-Cloud"
            });
            const bindResolved = (0,bindingDeviceResult/* resolveBindingDeviceResponse */.Ln)(bindResult, {
                platformType: "Android-Cloud",
                onMessage: (opts)=>(0,Message/* messageInfo */.B)(opts)
            });
            if (!bindResolved.shouldContinue) {
                return;
            }
            window.localStorage.setItem("Basic", 1);
            window.localStorage.setItem("DeviceUser", JSON.stringify({
                username: useUserName,
                password: usePassWord
            }));
            // 下载数据
            let dow = await (0,_api_login.gcloudDownload)({
                mode: 4,
                username: useUserName,
                password: usePassWord
            });
            (0,Message/* messageInfo */.B)({
                content: dow.data.ed,
                duration: 6
            });
            setTimeout(async ()=>{
                await (0,_api_login.sendDownloadTime)({
                    username: useUserName,
                    type: "basic_download"
                });
            }, 1500);
            setTimeout(()=>{
                dispatch((0,Common/* fetchResetTime */.NZ)());
            }, 2000);
            setCurrentStep(3);
            // 绑定成功后刷新侧栏设备列表（SpyX 版没有这一步，Msafely 保留）
            (0,refreshSidebarDevices/* refreshSidebarDevices */.Ii)();
        // 发送下载时间
        }
    };
    // 限制时间
    const [isButtonDisabled, setIsButtonDisabled] = (0,react.useState)(false);
    const handleClickLimit = (time)=>{
        let initTime = 5000;
        if (time) {
            initTime = time;
        }
        if (!isButtonDisabled) {
            setIsButtonDisabled(true);
            setTimeout(()=>{
                setIsButtonDisabled(false);
            }, initTime) // x秒后重新启用按钮
            ;
            return true;
        } else {
            return false;
        }
    };
    // 开始登录
    const [useUserName, setUserName] = (0,react.useState)("");
    const [usePassWord, setPassWord] = (0,react.useState)("");
    const tipsOpen = (content)=>{
        (0,Message/* messageInfo */.B)({
            content: content,
            duration: 4
        });
    };
    const login = async ()=>{
        if (!handleClickLimit()) return;
        if (useUserName === "" || usePassWord === "") {
            tipsOpen("Value cannot be empty");
            return;
        }
        let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (!re.test(useUserName)) {
            tipsOpen("Please enter a vaild email.");
            return;
        }
        dataLayer.push({
            event: "android-cloud-app-finish"
        });
        let obj = {
            username: useUserName,
            password: usePassWord
        };
        let check = await (0,_api_login.gcloudAuth)(obj);
        if (check.data.ec === 0 || check.data.status) {
            actionData(check);
            setShowLogin(false);
            window.localStorage.setItem("Basic", 1);
            window.localStorage.setItem("DeviceUser", JSON.stringify({
                username: useUserName,
                password: usePassWord
            }));
        }
        tipsOpen(check.data.em);
    };
    onkeydown = (e)=>{
        if (e.keyCode === 13) {
            login();
        }
    };
    // 验证码
    const [verifyCode, setVerifyCode] = (0,react.useState)("");
    // 密钥提交
    const [phone, setPhone] = (0,react.useState)("");
    const [digitKey, setDigitKey] = (0,react.useState)("");
    const handleSubmit = async ()=>{
        if (phone == "") {
            tipsOpen("Please enter the whatsapp number");
            return;
        }
        if (digitKey.length !== 64) {
            tipsOpen("Please enter the correct key");
            return;
        }
        let username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        let result = await (0,dashboard/* androidWaKey */.gI)({
            googleAccount: username,
            waAccount: phone,
            encryptionKey: digitKey
        });
        ;
        if (result.data.ec === 0) {
            tipsOpen(result.data.em);
            let download = await (0,_api_login.gcloudDownload)({
                mode: 5,
                username: username
            });
            tipsOpen(download.data.ed);
            localStorage.setItem("encryption-key", true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: showLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (index_module_default()).login_box,
            style: paramsStyles.data,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (index_module_default()).close_box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                        icon: "iconamoon:close-bold",
                        className: (index_module_default()).close_icon,
                        onClick: ()=>setShowLogin(false)
                    })
                }),
                currentStep == 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).start_box,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default()).guide,
                            children: t("You can connect the target device through one of the three methods below. Click the button to start!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: startData.map((row, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (index_module_default()).title,
                                            children: row.title
                                        }),
                                        row.subtitle.map((child)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (index_module_default()).subtitle,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: child
                                                    })
                                                ]
                                            }, child))
                                    ]
                                }, row.title))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default()).start_btn,
                            onClick: ()=>setCurrentStep(2),
                            children: t("Start")
                        })
                    ]
                }) : null,
                currentStep === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).connect_box,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (index_module_default()).tags_box,
                            children: connectType.map((row, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: index + 1 === startType ? (index_module_default()).select_li : "",
                                    onClick: ()=>{
                                        dataLayer.push({
                                            event: "android-selected-type",
                                            value: index == 0 ? "dashboard" : index == 1 ? "App" : "Plugin"
                                        });
                                        setStartType(index + 1);
                                    },
                                    children: row
                                }, index + 1))
                        }),
                        (()=>{
                            if (startType === 1) {
                                // 登录成功
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newGcloudLoing, {})
                                });
                            } else if (startType === 2) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (index_module_default()).app_box,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (index_module_default()).title,
                                            children: t("Connect target device in app")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* default */.Z, {
                                            ref: carouselRef,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (index_module_default()).subtitle,
                                                            children: t("All the set up steps below must proceed on an Android phone. (Not limit to the target phone)")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "end",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        onClick: nextSlide,
                                                                        src: "/images/login/right.png",
                                                                        width: "40",
                                                                        height: "40",
                                                                        alt: "img"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[30%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "6px auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/app.png",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    style: {
                                                                        marginTop: "10px",
                                                                        width: "200px",
                                                                        height: "36px",
                                                                        background: "#EFF3F4",
                                                                        outline: "none",
                                                                        fontSize: "20px",
                                                                        fontWeight: "600",
                                                                        paddingLeft: "10px"
                                                                    },
                                                                    type: "text",
                                                                    ref: inputRef,
                                                                    value: "italk.cc/6",
                                                                    readOnly: true,
                                                                    onClick: ()=>{
                                                                        // 选择输入框的文本
                                                                        inputRef.current.select();
                                                                        // 复制文本到剪贴板
                                                                        document.execCommand("copy");
                                                                        // 取消文本选择
                                                                        window.getSelection().removeAllRanges();
                                                                        tipsOpen("copy");
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                    onClick: ()=>{
                                                                        // 选择输入框的文本
                                                                        inputRef.current.select();
                                                                        // 复制文本到剪贴板
                                                                        document.execCommand("copy");
                                                                        // 取消文本选择
                                                                        window.getSelection().removeAllRanges();
                                                                        tipsOpen("copy");
                                                                    },
                                                                    icon: "material-symbols:content-copy",
                                                                    color: "#C2C5D5",
                                                                    fontSize: "26px",
                                                                    style: {
                                                                        marginTop: "11px",
                                                                        position: "relative",
                                                                        left: "-25px"
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step1"),
                                                                ":",
                                                                " ",
                                                                t("scan the QR code or open the link below in the browser on the tartget device.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "6px auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/app2.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step2"),
                                                                ":",
                                                                " ",
                                                                t("Download the Google Account Verification App on your Android phone. If a warning window is shown, click “Download anyway”. (This app is just for verification; once you can see data on the dashboard, you are free to delete it.)")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app3.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step3"),
                                                                ": ",
                                                                t("Wait a few seconds to download, and click Open.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app4.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                " ",
                                                                t("Step4"),
                                                                ": ",
                                                                t("Click Install.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app5.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step5"),
                                                                ": ",
                                                                t("Wait a few seconds to install, and click Open.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app6.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                " ",
                                                                t("Step6"),
                                                                ": ",
                                                                t("If a window is shown, click Allow")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app7.png",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step7"),
                                                                ": ",
                                                                t("Fill in the Google account on the target phone you want to monitor.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app8.png",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step8"),
                                                                ": ",
                                                                t("Fill in the password of the Google account.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[40%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app9.png",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step9"),
                                                                ":",
                                                                " ",
                                                                t(" Depending on the target phone, one of the 2-step verification methods will randomly appear. If you see something different, don't panic, just follow the guide on the app to finish the verification.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        onClick: prevSlide,
                                                                        src: "/images/login/left.png",
                                                                        width: "40",
                                                                        height: "40",
                                                                        alt: "img"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[25%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto"
                                                                    },
                                                                    src: "/images/login/app10.png",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (index_module_default()).finish,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    position: "relative",
                                                                    marginTop: "20px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (index_module_default()).input_box,
                                                                        style: {
                                                                            marginTop: "40px"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                src: "/images/login/google.svg",
                                                                                width: "16",
                                                                                height: "16",
                                                                                alt: "img"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                className: (index_module_default()).input,
                                                                                placeholder: "Google account",
                                                                                onChange: (e)=>setUserName(e.target.value.trim())
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (index_module_default()).input_box,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                src: "/images/login/password.svg",
                                                                                width: "18",
                                                                                height: "18",
                                                                                alt: "img"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                className: (index_module_default()).input,
                                                                                type: "password",
                                                                                placeholder: "Password",
                                                                                onChange: (e)=>setPassWord(e.target.value.trim())
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (index_module_default()).btn,
                                                                        onClick: ()=>{
                                                                            login();
                                                                        },
                                                                        children: t("Finish")
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step10"),
                                                                ": ",
                                                                t("After complete the verification, click"),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        fontWeight: "600"
                                                                    },
                                                                    children: t("I agree.")
                                                                }),
                                                                t("Then fill in Google account and password again at the top"),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    style: {
                                                                        fontWeight: "600"
                                                                    },
                                                                    children: t("(this time no verification message will be sent).")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: t("Now that the connection is complete, you can delete the app.")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            } else if (startType === 3) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (index_module_default()).app_box,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (index_module_default()).title,
                                            children: t("Install the plugin")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (index_module_default()).subtitle,
                                            style: {
                                                marginBottom: "10px"
                                            },
                                            children: t("All the set up steps below must proceed in Chrome on a PC.")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* default */.Z, {
                                            ref: carouselRef,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[80%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/plugin1.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step1"),
                                                                ": Open the",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "https://chrome.google.com/webstore/detail/http-developer-aids/bmkpibhkckdgncchaodfphkhipmiinga",
                                                                    target: "_blank",
                                                                    style: {
                                                                        textDecoration: "underline",
                                                                        color: "blue"
                                                                    },
                                                                    rel: "noreferrer",
                                                                    children: "plugin install page"
                                                                }),
                                                                " ",
                                                                "on Chrome and click “Add to Chrome”."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[80%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/plugin2.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                " ",
                                                                t("Step2"),
                                                                ": ",
                                                                t("Click Add extension.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[80%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/plugin3.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step3"),
                                                                ":",
                                                                " ",
                                                                t("Click the extension icon in the upper right corner of Chrome. If you can see “HTTP Developer Aids”, you have installed the plugin successfully. "),
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[80%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/plugin4.png",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t("Step4"),
                                                                ": ",
                                                                t("Now you can"),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    onClick: ()=>{
                                                                        let accessToken = localStorage.getItem("accessToken");
                                                                        if (accessToken) {
                                                                            let url = "https://accounts.google.com/EmbeddedSetup?site=spyx&Authorization=Bucket ".concat(accessToken);
                                                                            window.open(url);
                                                                        }
                                                                    },
                                                                    href: "#",
                                                                    target: "_blank",
                                                                    style: {
                                                                        textDecoration: "underline",
                                                                        color: "blue"
                                                                    },
                                                                    children: [
                                                                        " ",
                                                                        t("Click Here.")
                                                                    ]
                                                                }),
                                                                t("to connect the device on PC. Then Fill in the Google account on the target phone you want to monitor.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[80%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/plugin5.png",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                " ",
                                                                t("Step5"),
                                                                ": ",
                                                                t("Fill in the password of the Google account.")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            position: "relative",
                                                            marginTop: "20px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    zIndex: "9",
                                                                    position: "absolute",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    width: "100%"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        onClick: prevSlide,
                                                                        src: "/images/login/left.png",
                                                                        width: "40",
                                                                        height: "40",
                                                                        alt: "img"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        onClick: nextSlide,
                                                                        src: "/images/login/right.png",
                                                                        width: "40",
                                                                        height: "40",
                                                                        alt: "img"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[80%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/plugin6.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: [
                                                                    t("Step6"),
                                                                    ":",
                                                                    " ",
                                                                    t("Depending on the target phone, one of the 2-Step verification methods will randomly appear. If you see something different, don t panic, just follow the guide on app to finish the verification. ")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            style: {
                                                                position: "relative",
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        zIndex: "9",
                                                                        position: "absolute",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        width: "100%"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: prevSlide,
                                                                            src: "/images/login/left.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            onClick: nextSlide,
                                                                            src: "/images/login/right.png",
                                                                            width: "40",
                                                                            height: "40",
                                                                            alt: "img"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "w-[80%] sm:w-[60%]",
                                                                    style: {
                                                                        margin: "auto",
                                                                        boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                        borderRadius: "6px"
                                                                    },
                                                                    src: "/images/login/plugin7.jpg",
                                                                    width: "10",
                                                                    height: "10",
                                                                    alt: "10"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                marginTop: "20px"
                                                            },
                                                            children: [
                                                                t('After completing the verification, click "I agree".'),
                                                                t('Then click the "Finish" button below.'),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "w-[50%] sm:w-[100%]",
                                                            style: {
                                                                margin: "20px auto",
                                                                borderRadius: "20px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                                background: "#fcd980",
                                                                color: "#000",
                                                                fontWeight: "500",
                                                                textAlign: "center"
                                                            },
                                                            onClick: ()=>{
                                                                setCurrentStep(3);
                                                            },
                                                            children: t("Finish")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }
                        })()
                    ]
                }) : null,
                currentStep === 3 && currentBackup === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).backup_box,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (index_module_default()).title,
                            children: [
                                " ",
                                t("Check back up settings")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (index_module_default()).subtitle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    style: {
                                        fontWeight: "600"
                                    },
                                    children: [
                                        " ",
                                        t("Congrats! The target device has been successfully connected.")
                                    ]
                                }),
                                t("While the data is downloading, please check all backup settings on the target phone to ensure you can make full use of Msafely.")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (index_module_default()).entire,
                            children: t("The entire process may take 3-5 minutes on the target phone. Please check whether backup is enabled for the app data you want to monitor:")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: (index_module_default()).ul,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        " ",
                                        t("Google drive")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        " ",
                                        t("Locations"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        " ",
                                        t("WhatsApp")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        " ",
                                        t("Photos & videos")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        " ",
                                        t("Chrome history & bookmarks")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        " ",
                                        t("Contact")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    children: [
                                        " ",
                                        t("Trouble shooting")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (index_module_default()).btn,
                            onClick: ()=>setCurrentBackup(2),
                            children: t("Start")
                        })
                    ]
                }) : null,
                currentStep === 3 && currentBackup === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (index_module_default()).backup_box,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs/* default */.Z, {
                        className: "android_login_tas",
                        activeKey: backActiveKey,
                        onChange: (e)=>{
                            setBackActiveKey(e);
                        },
                        tabPosition: isPc ? "left" : "top",
                        destroyInactiveTabPane: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPane, {
                                tab: "Google drive",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            fontWeight: "600",
                                            fontSize: "24px"
                                        },
                                        children: [
                                            " ",
                                            t("Turn on Google Drive back up")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            position: "relative",
                                            marginTop: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    zIndex: "9",
                                                    position: "absolute",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: prevSlide,
                                                        src: "/images/login/left.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: nextSlide,
                                                        src: "/images/login/right.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* default */.Z, {
                                                ref: carouselRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup1.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t("Open the Settings app on the target Android phone and click Accounts and Backup.")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup2.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: [
                                                                    " ",
                                                                    t("Click Backup data under Google Drive.")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto"
                                                                },
                                                                src: "/images/login/backup3.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t('Make sure the Google account is signed in and click "Back up now". If there is no account under Account storage, sign in first. The time displayed below "Backup by Google One" is the last time you backed up.')
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "1"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPane, {
                                tab: "Locations",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            fontWeight: "600",
                                            fontSize: "24px",
                                            textAlign: "center"
                                        },
                                        children: [
                                            " ",
                                            t("Back up Locations")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            position: "relative",
                                            marginTop: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    zIndex: "9",
                                                    position: "absolute",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: prevSlide,
                                                        src: "/images/login/left.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: nextSlide,
                                                        src: "/images/login/right.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* default */.Z, {
                                                ref: carouselRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup13.jpg",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                style: {
                                                                    marginTop: "20px",
                                                                    display: "initial"
                                                                },
                                                                children: [
                                                                    t("Open your device's Settings app"),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                        style: {
                                                                            display: "initial"
                                                                        },
                                                                        icon: "material-symbols:settings-outline",
                                                                        color: "#999999"
                                                                    }),
                                                                    " ",
                                                                    t("and tap Location.")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup14.jpg",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t("Turn on Location.")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup15.jpg",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t("Open your device s Settings app and tap Security and privacy.")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup16.jpg",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t("Tap Find My Device")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup17.jpg",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t("Check if “Find My Device” is turned on.")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "2"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPane, {
                                tab: "WhatsApp",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            fontWeight: "600",
                                            fontSize: "24px",
                                            textAlign: "center"
                                        },
                                        children: t("Back up WhatsApp")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Open WhatsApp"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step1"),
                                                    ":"
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "Tap",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                        icon: "ph:dots-three-outline-vertical-fill",
                                                        color: "#00887A",
                                                        style: {
                                                            display: "inline"
                                                        }
                                                    }),
                                                    " ",
                                                    "> Settings > Chats > Chat backup > End-to-end encrypted backup."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step2"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("Tap TURN ON.")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step3"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    t("Use a 64-digit encryption key instead.")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step4"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    t("Generate your 64-digit key.")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step5"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    t("Press and hold 64-digit key, click Copy.")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step6"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    t("I Saved My 64-digit key.")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step7"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("Tap Create to create your end- to-end encrypted backup.")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            display: "flex",
                                            marginTop: "4px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                style: {
                                                    fontWeight: "500"
                                                },
                                                children: [
                                                    t("Step8"),
                                                    ": "
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("Paste the 64-digit key below and click submit. (Or you can submit on WhatsApp feature page later)")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            padding: "10px",
                                            marginTop: "30PX"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                            style: {
                                                width: "100%",
                                                background: "#fff"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            textAlign: "center",
                                                            fontWeight: "700",
                                                            color: "#000",
                                                            fontSize: "16px"
                                                        },
                                                        children: "Enter your 64-digit key"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            color: "#696D6F",
                                                            marginTop: "10px"
                                                        },
                                                        children: "Enter WhatsApp number (include the country code at the start, e.g. US is +1, UK is +44). And paste the 64-digit key."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        placeholder: "WhatsApp Number",
                                                        style: {
                                                            marginTop: "10px",
                                                            borderRadius: "10px",
                                                            padding: "0 10px",
                                                            width: "100%",
                                                            height: "40px",
                                                            background: "#F7F8FA",
                                                            outline: "none"
                                                        },
                                                        onChange: (e)=>{
                                                            setPhone(e.target.value.trim());
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, {
                                                        className: "digit_key",
                                                        rows: 4,
                                                        placeholder: "64-digit key",
                                                        style: {
                                                            marginTop: "10px",
                                                            borderRadius: "10px",
                                                            padding: "0 10px",
                                                            width: "100%",
                                                            height: "40px",
                                                            background: "#F7F8FA",
                                                            border: "0",
                                                            height: "200px"
                                                        },
                                                        onChange: (e)=>{
                                                            setDigitKey(e.target.value.trim());
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            marginTop: "20px",
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                                            style: {
                                                                background: "#3874EA",
                                                                color: "#fff"
                                                            },
                                                            onClick: ()=>handleSubmit(),
                                                            children: "Submit"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, "3"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPane, {
                                tab: "Photos & videos",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            fontWeight: "600",
                                            fontSize: "24px",
                                            textAlign: "center"
                                        },
                                        children: [
                                            " ",
                                            t("Back up photos & videos")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            position: "relative",
                                            marginTop: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    zIndex: "9",
                                                    position: "absolute",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: prevSlide,
                                                        src: "/images/login/left.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: nextSlide,
                                                        src: "/images/login/right.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* default */.Z, {
                                                ref: carouselRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup4.jpg",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t('Open Google Photos. If there is no "Google Photos" on the device , install first.')
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup5.gif",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: t("Click the profile icon on the upper right corner, sign in the Google account and click Turn on backup.")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "4"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPane, {
                                tab: "Chrome",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            fontWeight: "600",
                                            fontSize: "24px",
                                            textAlign: "center"
                                        },
                                        children: [
                                            " ",
                                            t("Back up Chrome")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            position: "relative",
                                            marginTop: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    zIndex: "9",
                                                    position: "absolute",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: prevSlide,
                                                        src: "/images/login/left.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: nextSlide,
                                                        src: "/images/login/right.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* default */.Z, {
                                                ref: carouselRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup11.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: [
                                                                    t("Open Chrome, click the three dots icon on the upper right corner"),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                        icon: "ph:dots-three-outline-vertical-fill",
                                                                        style: {
                                                                            display: "initial"
                                                                        }
                                                                    }),
                                                                    t("click Settings"),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                        icon: "iconamoon:settings",
                                                                        style: {
                                                                            display: "initial"
                                                                        }
                                                                    }),
                                                                    t("click Sync")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup12.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: [
                                                                    " ",
                                                                    t("Turn on Sync everything")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "5"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPane, {
                                tab: "Contact",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        style: {
                                            fontWeight: "600",
                                            fontSize: "24px",
                                            textAlign: "center"
                                        },
                                        children: [
                                            " ",
                                            t("Back up contacts")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            position: "relative",
                                            marginTop: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    zIndex: "9",
                                                    position: "absolute",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: prevSlide,
                                                        src: "/images/login/left.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        onClick: nextSlide,
                                                        src: "/images/login/right.png",
                                                        width: "40",
                                                        height: "40",
                                                        alt: "img"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousel/* default */.Z, {
                                                ref: carouselRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup6.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: 'Open "Settings" and click Google'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup7.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: 'Click "Settings for Google apps"'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup8.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: 'Click "Google Contacts sync"'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup9.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: 'Click "Also sync device contacts"'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "w-[40%] sm:w-[60%]",
                                                                style: {
                                                                    margin: "6px auto",
                                                                    boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                                    borderRadius: "6px"
                                                                },
                                                                src: "/images/login/backup10.png",
                                                                width: "10",
                                                                height: "10",
                                                                alt: "10"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    marginTop: "20px"
                                                                },
                                                                children: 'Choose the backup account and turn on the "Automatically back up & sync device contacts"'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "6"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabPane, {
                                tab: "Trouble shooting",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            fontWeight: "600",
                                            fontSize: "24px",
                                            textAlign: "center"
                                        },
                                        children: t("Trouble shooting")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            position: "relative",
                                            marginTop: "20px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, {
                                            ref: carouselRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "w-[40%] sm:w-[60%]",
                                                        style: {
                                                            margin: "6px auto",
                                                            boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px",
                                                            borderRadius: "6px"
                                                        },
                                                        src: "/images/login/backup18.png",
                                                        width: "10",
                                                        height: "10",
                                                        alt: "10"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            marginTop: "20px"
                                                        },
                                                        children: t("1. Check the time shown under the Backup by Google One, if it' s inconsistent with the last backup time, click Back up now to back up again.")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        style: {
                                                            marginTop: "10px"
                                                        },
                                                        children: t("2. Check out the storage of the account, if there is no enough cloud storage, you need to upgrade the storage plan or try to delete some data.")
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, "7")
                        ]
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                    title: "",
                    closable: false,
                    open: guideOpen,
                    onCancel: ()=>setGuideOpen(false),
                    footer: [],
                    width: 340,
                    zIndex: 10000,
                    getContainer: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).guide_box,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (index_module_default()).title,
                                children: t("Verify error or password error")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (index_module_default()).content,
                                children: t("The target device has a high security level. Please try switch the connect method to connect in app or Chrome plugin.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).btn,
                                onClick: ()=>{
                                    setStartType(2);
                                    setCurrentStep(2);
                                    setGuideOpen(false);
                                },
                                children: [
                                    t("Connect in plugin"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("(Require a PC)")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_module_default()).btn,
                                onClick: ()=>{
                                    setStartType(1);
                                    setCurrentStep(2);
                                    setGuideOpen(false);
                                },
                                children: [
                                    t("Connect in app"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            t("(Require an Android phone)"),
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_module_default()).target,
                                children: t("*Not limit to the target phone")
                            })
                        ]
                    })
                }),
                contextHolder
            ]
        }) : null
    });
};
/* harmony default export */ var login = (AndroidLogin);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 12123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34745);
/* harmony import */ var src_utils_deviceDisconnect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22333);









const DisconnectDetection = ()=>{
    const [isShow, setIsShow] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const store = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)((state)=>state.Common);
    const selectedDeviceUserId = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const currentMode = store.currentMode || "";
    const shouldMonitor = (0,src_utils_deviceDisconnect__WEBPACK_IMPORTED_MODULE_8__/* .shouldMonitorDeviceDisconnect */ .w5)(router.pathname, currentMode);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setIsShow(false);
        const username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        if (!(0,src_utils_deviceDisconnect__WEBPACK_IMPORTED_MODULE_8__/* .shouldMonitorDeviceDisconnect */ .w5)(router.pathname, currentMode) || !username) {
            dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__/* .setConnectionStatus */ .bl)(false));
            return;
        }
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__/* .getConnectionStatus */ .Zp)());
    }, [
        dispatch,
        router.pathname,
        selectedDeviceUserId,
        currentMode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (store && store.isDisconnect) localStorage.setItem("isDisconnect", JSON.stringify(true));
        else localStorage.setItem("isDisconnect", JSON.stringify(false));
    }, [
        store
    ]);
    if (!shouldMonitor) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: store && store.isDisconnect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[21px] mb-[20px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full flex items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/common/warning.svg",
                            width: 22,
                            height: 22,
                            alt: "warning"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-[17px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-[13px] text-[#222222] font-[600] mb-2",
                                    children: t("Childs phone stopped transmitting data")
                                }),
                                !isShow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center cursor-pointer",
                                    onClick: ()=>setIsShow(true),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[13px] text-[#5035FF] font-[600] mr-[5px]",
                                            children: t("See details")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: "/images/common/drop-down2.svg",
                                            width: 12,
                                            height: 12,
                                            alt: "drop down"
                                        })
                                    ]
                                }),
                                isShow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center cursor-pointer",
                                    onClick: ()=>setIsShow(false),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[13px] text-[#5035FF] font-[600] mr-[5px]",
                                            children: t("Hide details")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: "/images/common/pull-up2.svg",
                                            width: 12,
                                            height: 12,
                                            alt: "pull-up"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isShow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-[18px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full bg-[#F5F6F7] rounded-[5px] p-[13px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    className: "text-[18px] text-[#282938] font-[600]",
                                    children: [
                                        t("Why"),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-[#333333] text-[12px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-[13px] mt-[3px] mb-[10px]",
                                            children: [
                                                t("This can happen due to one of the following reasons"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("The phone has not been connected to the internet for more than 24 hours")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("The phone was turned off for more than 24 hours")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Your kid turned on the battery saving mode that stopped Msafely")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Antivirus removed Msafely")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full bg-[#F5F6F7] rounded-[5px] p-[13px] mt-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    className: "text-[18px] text-[#282938] font-[600] mb-[10px]",
                                    children: [
                                        t("How do I fix this"),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-[#333333] text-[12px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Make sure the phone is switched on and connected to Wi-Fi or mobile data connection LTE")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Restart the phone wait for 30 mins then refresh this page")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        t("If this alert is still here it means you have to"),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            href: "https://msafely.net/download",
                                                            target: "_blank",
                                                            className: "text-[#2405F2]",
                                                            children: t("re-install Msafely")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full bg-[#F5F6F7] rounded-[5px] py-[10px] px-[12px] mt-[10px] flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "/images/common/re-install.svg",
                                    width: 50,
                                    height: 50,
                                    alt: "re install"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "ml-[15px] text-[12px] text-[#333333]",
                                    children: [
                                        t("In case you cant wait for 30 mins"),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "https://msafely.net/download",
                                            target: "_blank",
                                            className: "text-[#2405F2]",
                                            children: t("reinstall Msafely right away")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisconnectDetection);


/***/ }),

/***/ 22333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fb": function() { return /* binding */ usesLayoutDisconnectDetection; },
/* harmony export */   "w5": function() { return /* binding */ shouldMonitorDeviceDisconnect; }
/* harmony export */ });
/* unused harmony export DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT */
/** Dashboard 页面自行放置 DisconnectDetection，Layout 层不再渲染 */ const DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT = [
    "/dashboard",
    "/android/dashboard",
    "/android/local/dashboard"
];
/**
 * 当前路径是否使用 Layout 层断连检测（自定义 Dashboard 页返回 false）。
 * @param {string} pathname - Next.js router.pathname
 * @returns {boolean}
 */ const usesLayoutDisconnectDetection = (pathname)=>!DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT.includes(pathname);
/**
 * 是否应对当前页面启用 Android Local 断连轮询。
 * @param {string} pathname
 * @param {string} currentMode - Redux Common.currentMode
 * @returns {boolean}
 */ const shouldMonitorDeviceDisconnect = (pathname, currentMode)=>currentMode === "Android-Local" && pathname === "/android/local/dashboard";


/***/ }),

/***/ 49354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Af": function() { return /* binding */ refreshSubscriptionExpire; },
/* harmony export */   "Vk": function() { return /* binding */ RENEW_SUCCESS_REFRESH_DELAY; },
/* harmony export */   "dZ": function() { return /* binding */ reloadAfterRenewSuccess; },
/* harmony export */   "pG": function() { return /* binding */ matchCurrentDevice; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34745);


const readDeviceUser = ()=>{
    try {
        return JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
    } catch (e) {
        return {};
    }
};
/**
 * 在设备列表里定位当前设备（先按 device_id，再按 iCloud_username）。
 * 供「需要按设备接口判定平台类型」的页面复用。
 * @param {Array} list - user-device 接口返回的设备数组
 * @param {Object} deviceUser - localStorage DeviceUser 对象
 * @returns {Object|null}
 */ const matchCurrentDevice = (list, deviceUser)=>{
    const devices = Array.isArray(list) ? list : [];
    const deviceId = deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.device_id;
    const username = deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.username;
    if (deviceId != null && deviceId !== "") {
        const byId = devices.find((item)=>String(item.id) === String(deviceId) || String(item.device_id) === String(deviceId));
        if (byId) return byId;
    }
    if (username) {
        return devices.find((item)=>item.iCloud_username === username) || null;
    }
    return null;
};
/**
 * 续费 / 升级成功后无感刷新：
 * 1. 重拉设备列表写入 allDeviceUser
 * 2. 同步当前 DeviceUser.expire_time
 * 3. bump deviceSwitchRevision，驱动侧栏 / ExpiredMask 重算
 *
 * @param {Object} [params]
 * @param {import('redux').Dispatch} [params.dispatch]
 * @param {string} [params.expireTime] - 接口已返回的新到期时间，优先写入
 * @returns {Promise<{ ok: boolean, expireTime: string|null, device: Object|null }>}
 */ const refreshSubscriptionExpire = async function() {
    let { dispatch , expireTime  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (false) {}
    const prevDeviceUser = readDeviceUser();
    let devices = [];
    try {
        const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
        devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
        localStorage.setItem("allDeviceUser", JSON.stringify(devices));
    } catch (e) {
        ;
    }
    const matched = matchCurrentDevice(devices, prevDeviceUser);
    const nextExpire = expireTime || (matched === null || matched === void 0 ? void 0 : matched.expire_time) || (prevDeviceUser === null || prevDeviceUser === void 0 ? void 0 : prevDeviceUser.expire_time) || null;
    var _iCloud_username, _temporary, _order_id, ref, ref1, _subscription_status, ref2;
    const nextDeviceUser = {
        ...prevDeviceUser,
        ...matched ? {
            username: (_iCloud_username = matched.iCloud_username) !== null && _iCloud_username !== void 0 ? _iCloud_username : prevDeviceUser.username,
            temporary: (_temporary = matched.temporary) !== null && _temporary !== void 0 ? _temporary : prevDeviceUser.temporary,
            device_id: matched.id || matched.device_id || prevDeviceUser.device_id || "",
            order_id: (ref1 = (ref = (_order_id = matched.order_id) !== null && _order_id !== void 0 ? _order_id : matched.orderId) !== null && ref !== void 0 ? ref : prevDeviceUser.order_id) !== null && ref1 !== void 0 ? ref1 : null,
            subscription_status: (ref2 = (_subscription_status = matched.subscription_status) !== null && _subscription_status !== void 0 ? _subscription_status : prevDeviceUser.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
        } : {},
        ...nextExpire ? {
            expire_time: nextExpire
        } : {}
    };
    localStorage.setItem("DeviceUser", JSON.stringify(nextDeviceUser));
    if (typeof dispatch === "function") {
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .subscriptionRefreshed */ .Hw)());
    }
    return {
        ok: true,
        expireTime: nextExpire,
        device: matched
    };
};
/** 站内直接续费成功后延时整页刷新；软同步覆盖不全（banner / 遮罩仍可能停在已过期） */ const RENEW_SUCCESS_REFRESH_DELAY = 1500;
const reloadAfterRenewSuccess = function() {
    let delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : RENEW_SUCCESS_REFRESH_DELAY;
    if (false) {}
    window.setTimeout(()=>window.location.reload(), delay);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (refreshSubscriptionExpire)));


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ }),

/***/ 65132:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"login_box":"login_login_box__Kqji7","close_box":"login_close_box__H1AB_","close_icon":"login_close_icon__KZs50","start_box":"login_start_box__EKOx_","guide":"login_guide__GIK5Q","title":"login_title__R7A6X","subtitle":"login_subtitle__7tHWm","start_btn":"login_start_btn__7qadg","connect_box":"login_connect_box__F8Em9","tags_box":"login_tags_box__FH_ZW","select_li":"login_select_li__sF1o9","dashboard_box":"login_dashboard_box__jJLXa","tow_step":"login_tow_step__wafKc","monitor":"login_monitor__VPQvs","input_box":"login_input_box__lU5yw","input":"login_input__IztTq","robot_code":"login_robot_code__yFwV4","btn":"login_btn__ltbB_","verify_box":"login_verify_box__jhS_j","verify_select_box":"login_verify_select_box__Cq5vC","tutorial":"login_tutorial__XKLPf","security_box":"login_security_box__EXIy_","sms_box":"login_sms_box__9N1u8","verify":"login_verify__XLFOR","tutorial_step":"login_tutorial_step__qKrCw","device_box":"login_device_box__Qd5BG","guide_box":"login_guide_box__fZEvs","content":"login_content__q_WVg","target":"login_target__1rt1N","app_box":"login_app_box__BH4u8","finish":"login_finish__4ZXKk","backup_box":"login_backup_box__YvJ6c","entire":"login_entire__j6l5g","ul":"login_ul__q56aO"};

/***/ }),

/***/ 35951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dashboard_box":"newGcloundLogin_dashboard_box__j_yEo","title":"newGcloundLogin_title__rdILZ","tow_step":"newGcloundLogin_tow_step__j33w8","monitor":"newGcloundLogin_monitor__e_IpD","input_box":"newGcloundLogin_input_box__2ksXS","input":"newGcloundLogin_input__QKu2y","verify_box":"newGcloundLogin_verify_box__kutbD","robot_box":"newGcloundLogin_robot_box__Dweex","img_border":"newGcloundLogin_img_border__qtKSB","cell":"newGcloundLogin_cell__NpcLQ","btn":"newGcloundLogin_btn__OfA6r"};

/***/ })

}]);